import type React from "react"
import { SelectArrow } from "@/shared/components/ui/icons"
import { cn, TypeCheck } from "@/shared/utils"

export interface PaginationProps {
  currentPage: number
  totalPages: number
  onPageChange: (page: number) => void
}

const PaginationSelect: React.FC<PaginationProps> = ({ currentPage, totalPages, onPageChange }) => {
  const pageNumbers = []
  const ellipsis = "..."
  if (totalPages <= 5) {
    for (let i = 1; i <= totalPages; i++) {
      pageNumbers.push(i)
    }
  } else {
    if (currentPage <= 2) {
      pageNumbers.push(1, 2, 3, ellipsis, totalPages)
    } else if (currentPage >= totalPages - 2) {
      pageNumbers.push(1, ellipsis, totalPages - 2, totalPages - 1, totalPages)
    } else {
      pageNumbers.push(1, ellipsis, currentPage - 1, currentPage, currentPage + 1, ellipsis, totalPages)
    }
  }
  const cube = "h-9 w-9 flex items-center justify-center "
  return (
    <div className="ml-auto flex items-center">
      {currentPage > 1 && (
        <button title="Prev" className={cube} onClick={() => onPageChange(currentPage - 1)}>
          <SelectArrow className="rotate-90" />
        </button>
      )}
      {pageNumbers.map((page, index) => (
        <button
          key={index}
          onClick={() => TypeCheck.isNumber(page) && onPageChange(page)}
          className={cn(cube, currentPage === page && "rounded-md bg-pagination-bg")}
        >
          {page}
        </button>
      ))}
      {currentPage < totalPages && (
        <button title="Next" className={cube} onClick={() => onPageChange(currentPage + 1)}>
          <SelectArrow className="-rotate-90" />
        </button>
      )}
    </div>
  )
}

export default PaginationSelect
